import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { companyInfo } from '../mock';

export const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            اتصل بنا
          </h2>
          <div className="w-24 h-1 bg-blue-900 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            نحن هنا لخدمتك. تواصل معنا للإستفسار عن قطع الغيار أو أي استفسار آخر
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Phone */}
          <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="h-8 w-8 text-blue-900" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">الهاتف</h3>
              <a
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="text-gray-600 hover:text-blue-900 transition-colors" dir="ltr"
              >
                {companyInfo.phone}
              </a>
            </CardContent>
          </Card>

          {/* Email */}
          <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="h-8 w-8 text-blue-900" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">البريد الإلكتروني</h3>
              <a
                href={`mailto:${companyInfo.email}`}
                className="text-gray-600 hover:text-blue-900 transition-colors break-all"
              >
                {companyInfo.email}
              </a>
            </CardContent>
          </Card>

          {/* Address */}
          <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="h-8 w-8 text-blue-900" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">العنوان</h3>
              <p className="text-gray-600">{companyInfo.address}</p>
            </CardContent>
          </Card>

          {/* Working Hours */}
          <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="h-8 w-8 text-blue-900" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">ساعات العمل</h3>
              <p className="text-gray-600">{companyInfo.workingHours}</p>
            </CardContent>
          </Card>
        </div>

        {/* Map Section */}
        <div className="bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold mb-4">زر موقعنا</h3>
            <p className="text-xl text-blue-100 mb-6">
              قم بزيارتنا في زليتن، ليبيا للحصول على أفضل قطع الغيار لسيارتك
            </p>
            <div className="inline-flex items-center gap-2 bg-white text-blue-900 px-8 py-4 rounded-lg font-bold">
              <MapPin className="h-6 w-6" />
              <span className="text-lg">{companyInfo.address}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};